import React, { Component } from 'react';
import _ from 'lodash';
import { Label, Button } from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Excel from 'exceljs';
import FileSaver from 'file-saver';

import Service from './services';
import { PaginationTotal } from '../../../commons/controls';
import QueryEmptyState from '../../../commons/queryempty';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import NumberFormatter from '../../../commons/NumberFormatter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../KeszletTooltips';
import SelectField from '../../../components/Form/SelectField'
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';
import ProgressButton from '../../../commons/ProgressButton';


class KeszletinformacioLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cikkek: [],
      raktarakJson: [],
      raktarak: [],
      cikk: null,
      raktar: null,
      id: null,
      cikkszam: '',
      megnevezes: '',
      mennyisegiEgyseg: '',
      foglalasok: null,
      queryText: '',
      raktarFormStatus: 'LOAD', // [LOAD', NETW', 'LIST', 'DATA', 'QUERY']
      foglalasFormStatus: 'LOAD', // [LOAD', NETW', 'LIST', 'DATA', 'QUERY']
      keresesButtonLoading: false,
      xlsxButtonLoading: false,
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.listRaktar();
  }

  listRaktar = () => {
    Service.queryRaktar('', (err, res) => {
      if (!err) {
        const options = res[0];
        this.setState({
          raktarakJson: options
        });

        if(!this.state.raktar && options.length === 1) {
          this.setState({ raktar: options[0] });
        }
      }
    });
  }

  
  handleInputChangeCikkek = (value, { action }) => {
    switch (action) {
      case 'input-change':
        if (value && value.length > 0) {
          Service.queryCikk(value, false, false, null, (err, res) => {
            if (!err) {
              this.setState({
                cikkek: res[0]
              });
            }
          });
        }
        break;
      default:
    }
  }

  handleCikkChange = (newValue) => {
    const emptyCikk = {
      cikkszam: '',
      megnevezes: '',
      mennyisegiEgyseg: ''
    }
    if (!newValue || newValue.length == 0) {
      this.setState({ cikk: emptyCikk, raktarak: [], foglalasok: null, raktarFormStatus: 'DATA' });
    } else {
      this.setState({ cikk: newValue });
    }
  }

  handleRaktarChange = (newValue) => {
    const emptyRaktar = {};
    if (!newValue || newValue.length == 0) {
      this.setState({ raktar: emptyRaktar, raktarak: [], foglalasok: null, raktarFormStatus: 'DATA' });
    } else {
      this.setState({ raktar: newValue });
    }
  }

  loadData = () => {
    let cikkids = [];
    let raktarids = [];
    if (this.state.cikk)
      cikkids.push(this.state.cikk.id);
    if (this.state.raktar)
      raktarids.push(this.state.raktar.id);
      let jo = false;
      for (let i = 0; i < cikkids.length; i++) {
        if (cikkids[i]) {
          jo = true;
          break;
        }
      }
      if (!jo) {
        for (let i = 0; i < raktarids.length; i++) {
          if (raktarids[i]) {
            jo = true;
            break;
          }
        }
      }
    if (!jo) {
      this.setState({ raktarFormStatus: 'QUERY'});
    } else {
      this.setState({keresesButtonLoading: true});
      Service.getRaktarList(cikkids, raktarids, this.state.keszletszintSzuro?.id, (err, res) => {
        if (!err) {
          let raktarFormStatus;
          if (res[0].length > 0) raktarFormStatus = 'LIST'; else raktarFormStatus = 'DATA';
          this.setState({ raktarak: res[0], foglalasok: null, raktarFormStatus, keresesButtonLoading: false }, () => {
          });
        } else {
          this.setState({ raktarFormStatus: 'NETW', keresesButtonLoading: false });
        }
      });
    }
  }

  onRowSelect = (nyilv) => {
    if (nyilv) {
      Service.getFoglalasok(nyilv.cikkid, nyilv.raktar.id, (err, res) => {
        if (!err) {
          let foglalasFormStatus;
          if (res[0].length > 0) foglalasFormStatus = 'LIST'; else foglalasFormStatus = 'DATA';
          this.setState({ foglalasok: res[0], foglalasFormStatus });
        } else {
          this.setState({ foglalasFormStatus: 'NETW' });
        }
      });
    }
  }

  hasKeszletszintRole = () => {
    return this.props.globals.hasRole(['KESZLETNYILV_KESZLETSZINT'], false);
  }

  todayDate = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    return date.getFullYear() + '_' + (month < 10 ? '0' + month : month) + '_' + date.getDate();
  }

  // mozgastipusFormatter = (mozgastipus) => {
  //   switch (mozgastipus) {
  //     case 'MUNKALAP': return 'Munkalap';
  //     case 'VEVOI_RENDELES': return 'Vevői rendelés';
  //     case null: return 'Készletcsökkenés';
  //     default: return 'Ismeretlen';
  //   }
  // }

  renderTable = () => {
    const selectRowProp = {
      mode: 'radio',
      onSelect: this.onRowSelect
    };

    let columns = [
      {
        dataField: 'raktarNev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true,
        csvText: 'Raktar',
      },
      {
        dataField: 'cikk.cikkcsoport.nev',
        text: 'Cikkcsoport',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true,
        csvText: 'Cikkcsoport',
      },
      {
        dataField: 'cikkNev',
        text: 'Cikk',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true,
      },
      {
        dataField: 'cikk.mennyisegiEgyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true,
      }
    ];
    if (this.hasKeszletszintRole())
      columns = columns.concat([
        {
          dataField: 'minimumKeszletszint',
          text: 'Minimum készletszint',
          filter: textFilter({
            delay: 400,
            placeholder: 'Keresés...'
          }),
          formatter: v => NumberFormatter.addSpacesToString(v, NumberFormatter.OSSZEG),
          style: (cell, row) => {
            if (row.minimumKeszletszint != undefined && row.minimumKeszletszint >= row.szabadMennyiseg)
              return { backgroundColor: '#ff4545' };
          },
          sort: true,
        },
        {
          dataField: 'maximumKeszletszint',
          text: 'Maximum készletszint',
          filter: textFilter({
            delay: 400,
            placeholder: 'Keresés...'
          }),
          formatter: v => NumberFormatter.addSpacesToString(v, NumberFormatter.OSSZEG),
          style: (cell, row) => {
            if (row.maximumKeszletszint != undefined && row.maximumKeszletszint <= row.szabadMennyiseg)
              return { backgroundColor: '#ff4545' };
          },
          sort: true,
        }
      ]);
    columns = columns.concat([
      {
        dataField: 'teljesMennyiseg',
        text: 'Teljes készlet',
        csvText: 'Teljes keszlet',
        formatter: NumberFormatter.formatterSpaceOsszeg,
        style: { textAlign: 'right' },
        sort: true,
      },
      {
        dataField: 'foglaltMennyiseg',
        text: 'Foglalt készlet',
        csvText: 'Foglalt keszlet',
        formatter: NumberFormatter.formatterSpaceOsszeg,
        style: { textAlign: 'right' },
        sort: true,
      },
      {
        dataField: 'szabadMennyiseg',
        text: 'Szabad készlet',
        csvText: 'Szabad keszlet',
        formatter: NumberFormatter.formatterSpaceOsszeg,
        style: { textAlign: 'right' },
        sort: true,
      }
    ]);

    return (
      <div className="animated fadeIn">
        <BootstrapTable2
          bootstrap4
          ref={((c) => { this.lista = c; })}
          keyField="id"
          filter={filterFactory()}
          data={this.state.raktarak}
          columns={columns}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          selectRow={selectRowProp}
          rowStyle={row => {
            if (row.teljesMennyiseg === 0) return { backgroundColor: '#cfd8dc' };
          }}
        />
      </div>
    );
  }

    renderTablefoglalasok = () => {
      const columns = [
        // {
        //   dataField: 'mozgastipus',
        //   text: 'Mozgástípus',
        //   formatter: this.mozgastipusFormatter
        // },
        {
          dataField: 'funkcio.caption',
          text: 'Funkció',
        },
        {
          dataField: 'mennyiseg',
          text: 'Mennyiség',
          formatter: NumberFormatter.formatterSpaceOsszeg,
          style: NumberFormatter.styleTextAlign
        },
        {
          dataField: 'cikk',
          text: 'Mennyiségi egység',
          formatter: c => c.mennyisegiEgyseg
        },
        {
          dataField: 'mozgasDatum',
          text: 'Foglalás dátuma',
          formatter: d => TimeFormatter.formatDateTime(d)
        },
      ];

      return (
        <div className="animated fadeIn">
          <BootstrapTable2
            bootstrap4
            keyField="id"
            data={this.state.foglalasok}
            columns={columns}
            pagination={paginationFactory(Lib.bootstraptableProps)}
          />
        </div>
      );
    }


    render() {
      return (
        <div className="animated fadeIn">
          <RFForm onSubmit={() => {}}>
            <div className="row" style={{ paddingLeft: 20, paddingTop: 20, paddingRight: 20 }}>
              <div className="col-md-6">
                <SelectField
                  label='Raktár keresés:'
                  labelComponent='h6'
                  name="raktarnev"
                  id="raktarnev"
                  noOptionsMessage={() => "Nincs keresési eredmény"}
                  searchPromptText="Kezdj el gépelni a kereséshez..."
                  placeholder="Kezdj el gépelni a kereséshez..."
                  loadingMessage={() => "Keresés..."}
                  isClearable
                  ignoreAccents={false}
                  isLoading={false}
                  value={this.state.raktar}
                  onChange={this.handleRaktarChange}
                  options={this.state.raktarakJson}
                  getOptionValue={option => option}
                  getOptionLabel={option => option.nev}
                />
              </div>
              <div className="col-md-6">
                <SelectField
                  label='Cikk keresés (megnevezés alapján):'
                  labelComponent='h6'
                  name="cikknev"
                  id="cikknev"
                  noOptionsMessage={() => "Nincs keresési eredmény"}
                  searchPromptText="Kezdj el gépelni a kereséshez..."
                  placeholder="Kezdj el gépelni a kereséshez..."
                  loadingMessage={() => "Keresés..."}
                  isClearable
                  ignoreAccents={false}
                  isLoading={false}
                  onInputChange={_.debounce(this.handleInputChangeCikkek, 1000)}
                  onChange={this.handleCikkChange}
                  options={this.state.cikkek}
                  getOptionValue={option => option}
                  getOptionLabel={option => option.megnevezes}
                />
              </div>
            </div>
            <div className="row" style={{ paddingLeft: 20, paddingTop: 10, paddingRight: 20 }} >
              <div className="col-md-2">
                <RFField
                  label="Cikk szám:"
                  disabled
                  name="cikkszam"
                  value={this.state.cikk ? this.state.cikk.cikkszam : ''}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  label="Cikk megnevezése:"
                  disabled
                  name="cikk-megnevezese"
                  value={this.state.cikk ? this.state.cikk.megnevezes : ''}
                />
              </div>
              <div className="col-md-2">
                <RFField
                  label="Mennyiség egység: "
                  disabled
                  name="mennyiseg"
                  value={this.state.cikk ? this.state.cikk.mennyisegiEgyseg : ''}
                />
              </div>
              {this.hasKeszletszintRole() && <div className="col-md-2">
                <SelectField
                  label="Készletszint limit elérés: "
                  name="keszletszintSzuro"
                  id="keszletszintSzuro"
                  placeholder="Válassz értéket..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  searchPromptText="Kezdj el gépelni a kereséshez..."
                  loadingMessage={() => 'Keresés...'}
                  onChange={(v) => this.setState({ keszletszintSzuro: v })}
                  options={[
                    { id: 1, name: 'Minimum'},
                    { id: 2, name: 'Maximum'},
                    { id: 3, name: 'Mindkettő'},
                  ]}
                  isClearable
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                />
              </div>}
            </div>
            <div className="row" style={{ paddingLeft: 20 }}>
              <div className="col-md-auto">
                <ProgressButton type="button" color="primary" onClick={() => this.loadData()} loading={this.state.keresesButtonLoading}>
                  Keresés
                </ProgressButton>
              </div>
              <div className='col-md-auto'>
                <ProgressButton
                  type="button"
                  className="btn btn-success"
                  style={{ marginBottom: 10 }}
                  loading={this.state.xlsxButtonLoading}
                  onClick={() => {
                    const datas = JSON.parse(JSON.stringify(this.lista.filterContext.data));
                    let xlsDatas = [];
                    datas.forEach((element) => {
                      if (this.hasKeszletszintRole())
                        xlsDatas.push([
                          element.raktar.nev, element.cikk.cikkcsoport.nev, element.cikkNev, element.cikk.mennyisegiEgyseg, element.minimumKeszletszint, element.maximumKeszletszint, NumberFormatter.addSpacesToString(element.teljesMennyiseg, NumberFormatter.OSSZEG), NumberFormatter.addSpacesToString(element.foglaltMennyiseg, NumberFormatter.OSSZEG), NumberFormatter.addSpacesToString(element.szabadMennyiseg, NumberFormatter.OSSZEG)
                        ]);
                      else
                        xlsDatas.push([
                          element.raktar.nev, element.cikk.cikkcsoport.nev, element.cikkNev, element.cikk.mennyisegiEgyseg, NumberFormatter.addSpacesToString(element.teljesMennyiseg, NumberFormatter.OSSZEG), NumberFormatter.addSpacesToString(element.foglaltMennyiseg, NumberFormatter.OSSZEG), NumberFormatter.addSpacesToString(element.szabadMennyiseg, NumberFormatter.OSSZEG)
                        ]);
                    });

                    const wb = new Excel.Workbook();
                    let ws = wb.addWorksheet('Készletinformáció');

                    ws.columns = [
                      { key: 'raktar', width: 35 },
                      { key: 'cikkcsoport', width: 35 },
                      { key: 'cikk', width: 35 },
                      { key: 'mennyesigeiegyseg', width: 20 },
                    ];
                    if (this.hasKeszletszintRole())
                      ws.columns = ws.columns.concat([
                        { key: 'minimumkeszletszint', width: 20, style: { alignment: { horizontal: 'right' }}},
                        { key: 'maximumkeszletszint', width: 20, style: { alignment: { horizontal: 'right' }}},
                      ]);
                    ws.columns = ws.columns.concat([
                      { key: 'teljes', width: 20, style: { alignment: { horizontal: 'right' }}},
                      { key: 'foglalt', width: 20, style: { alignment: { horizontal: 'right' }}},
                      { key: 'szabad', width: 20, style: { alignment: { horizontal: 'right' }}},
                    ]);

                    let headerColumns = [
                      { name: 'Raktár', filterButton: true },
                      { name: 'Cikkcsoport', filterButton: true },
                      { name: 'Cikk', filterButton: true },
                      { name: 'Mennyiségi egység', filterButton: true },
                    ];

                    if (this.hasKeszletszintRole())
                      headerColumns = headerColumns.concat([
                        { name: 'Minimum készletszint', filterButton: true },
                        { name: 'Maximum készletszint', filterButton: true },
                      ]);

                    headerColumns = headerColumns.concat([
                      { name: 'Teljes készlet', filterButton: true },
                      { name: 'Foglalt készlet', filterButton: true },
                      { name: 'Szabad készlet', filterButton: true },
                    ]);

                    ws.addTable({
                      name: 'Táblázat',
                      ref: 'A1',
                      headerRow: true,
                      style: {
                        theme: 'TableStyleLight1',
                        showRowStripes: true,
                      },
                      columns: headerColumns,
                      rows: xlsDatas,
                    });
                    ws.getRow(1).alignment = 'left';
                    if (datas.length > 0) {
                      this.setState({xlsxButtonLoading: true});
                      wb.xlsx.writeBuffer()
                        .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'keszletinfo_' + this.todayDate() + '.xlsx'))
                        .catch()
                        .finally(() => {
                          this.setState({xlsxButtonLoading: false});
                        });
                    }
                  }}
                >
                  Export xlsx
                </ProgressButton>
              </div>
            </div>
          </RFForm>
          <div className="row" style={{ padding: 20 }}>
            <div className="col-md-12">
              <div>
                {{
                  LIST: (this.renderTable()),
                  // LOAD:  (<Loader />),
                  NETW: (<NetworkEmptyState hasImage />),
                  DATA: (<DataEmptyState hasImage title="Nincs megjeleníthető adat!" subtitle="" />),
                  QUERY: (<QueryEmptyState hasImage />)
                }[this.state.raktarFormStatus]}
              </div>
            </div>
          </div>
          <hr style={{ height: '10px', boreder: '10px' }} />
          {this.state.foglalasok
          && (
            <React.Fragment>
              <div className="row" style={{ paddingLeft: 20 }}>
                <div className="col-md-2">
                  <h5>Foglalások</h5>
                </div>
              </div>
              <div className="row" style={{ padding: 20 }}>
                <div className="col-md-12">
                  <div>
                    {{
                      LIST: (this.renderTablefoglalasok()),
                      LOAD: (<Loader />),
                      NETW: (<NetworkEmptyState hasImage />),
                      DATA: (<DataEmptyState hasImage title="Nincs megjeleníthető adat!" subtitle="" />)
                    }[this.state.foglalasFormStatus]}
                  </div>
                </div>
              </div>
            </React.Fragment>
            )
          }
        </div>
      );
    }
}

export default KeszletinformacioLista;
